import { MaterialCatagoryStateTypes, MaterialCatagoryActionTypes } from "./MaterialCatagory.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: MaterialCatagoryStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const MaterialCatagoryReducer = (
  state: MaterialCatagoryStateTypes = INITIAL_STATE,
  action: any
): MaterialCatagoryStateTypes => {
  switch (action.type) {
    case MaterialCatagoryActionTypes.FETCH_ALL_MATERIAL_CATAGORY:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case MaterialCatagoryActionTypes.FETCH_ALL_MATERIAL_CATAGORY_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MaterialCatagoryActionTypes.FETCH_ALL_MATERIAL_CATAGORY_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MaterialCatagoryActionTypes.FETCH_ALL_MATERIAL_CATAGORY_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case MaterialCatagoryActionTypes.FETCH_ONE_MATERIAL_CATAGORY:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case MaterialCatagoryActionTypes.FETCH_ONE_MATERIAL_CATAGORY_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MaterialCatagoryActionTypes.FETCH_ONE_MATERIAL_CATAGORY_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MaterialCatagoryActionTypes.FETCH_ONE_MATERIAL_CATAGORY_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default MaterialCatagoryReducer;
